import React from "react";
import dmgphoneimg from "../../assets/images/DMG_phone.png";
import dmgpmailimg from "../../assets/images/DMG_mail.png";
import dmgpclockimg from "../../assets/images/DMG_clock.png";
import facebook from "../../assets/images/facebook.png";
import linkedin from "../../assets/images/linkedin.png";
import twitter from "../../assets/images/twitter-bird.svg";
import dmglogofooter from "../../assets/images/DMG-logo_footer.png";
import "./footer.css";
import { Link } from "react-router-dom";

class Footer extends React.Component {
  render() {
    const pathname = window.location.pathname;
    const acceptedPaths =
      ["/technicians", "/providers", "/contactus"].indexOf(pathname) > -1;

    return (
      <footer
        className={acceptedPaths ? "footer-additional" : "footer-section"}
      >
        <div className="container">
          <div className="footer-content">
            <div className="row py-lg-5 py-4">
              <div className="col-xl-4 col-lg-4 col-md-12 mt-3 order-lg-2">
                <a href="/">
                  <img
                    src={dmglogofooter}
                    className="img-fluid"
                    alt="Footer Logo"
                  />
                </a>
              </div>
              <div className="col-xl-4 col-lg-4 col-4 order-lg-0">
                <div className="footer-widget">
                  <div className="footer-widget-heading">
                    <p>Company</p>
                  </div>
                  <ul>
                    <li>
                      <Link to="/aboutus"> About Us</Link>
                    </li>
                    <li style={{ display: "none" }}>
                      <a href="/">Mechanical</a>
                    </li>
                    <li>
                      <Link to="/technicians">Technicians</Link>
                    </li>
                    <li>
                      <Link to="/contactus"> Contact Us</Link>{" "}
                    </li>
                    <li>
                      <Link to="/providers"> Providers</Link>
                    </li>
                    <li>
                      <Link to="/services"> Services</Link>
                    </li>
                    {/* <li><a href="#">Portal Login</a></li> */}
                    {/* <li><a href="#">Careers</a></li>
                                    <li className="invisible d-none d-lg-block"><a href="#">&nbsp</a></li>
                                    <li><a href="#">News</a></li> */}
                  </ul>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-8 order-lg-1">
                <div className="footer-address">
                  <div className="footer-widget-heading">
                    <p>Reach out to us</p>
                  </div>
                  <ul className="list-unstyled">
                    <li>
                      <a href="tel:(850) 920-4901">
                        <img
                          src={dmgphoneimg}
                          className="me-2"
                          alt="Phone Icon"
                        />{" "}
                        (970) 696-8906
                      </a>
                    </li>
                    <li>
                      <a
                        href="mailto:servicedesk@dmgpro.com"
                        className="text-lowercase"
                      >
                        <img
                          src={dmgpmailimg}
                          className="me-2"
                          alt="Mail Icon"
                        />{" "}
                        servicedesk@dmgpro.com 
                      </a>
                    </li>
                    <li>
                      <a href="#9am">
                        <img
                          src={dmgpclockimg}
                          className="me-2"
                          alt="Clock Icon"
                        />{" "}
                        9am-6pm
                      </a>
                    </li>
                  </ul>
                  <br />
                  <div className="footer-social-icon">
                    <div className="footer-widget-heading">
                      <p>Stay Connected</p>
                    </div>
                    <a
                      href="https://www.facebook.com/DivisionsHQ/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={facebook} alt="Facebook Icon" />
                    </a>
                    {/* <a href="#"><img src={instagram} alt="Instagram Icon"/></a> */}
                    <a
                      href="https://www.linkedin.com/company/divisions-maintenance-group/?viewAsMember=true&original_referer=https%3A%2F%2Fdivisionsmg.com%2Fcontact-us%2F"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={linkedin} alt="Linkedin Icon" />
                    </a>
                    <a
                      href="https://twitter.com/divisionshq?lang=en"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={twitter} alt="Twitter Icon" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <hr className="mt-0" />
            <div className="row pb-4 pt-2">
              <div className="col-xl-6 col-lg-6 col-md-12 order-lg-1">
                <p className="float-lg-end mb-0 grey">
                  <a href="/terms-and-conditions">Terms & Conditions</a>{" "}
                  <span className="mx-3">|</span>{" "}
                  <a href="/privacy-policy">Privacy Policy</a>{" "}
                </p>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 order-lg-0">
                <p className="mb-0 grey">
                  © 2022-2023, Divisions Maintenance Group All Rights Reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
